import { useState } from "react";

import styles from "../../styles/__chatModal.module.scss";
import { ArrowLeft, Upload, Send, MoreVertical } from "lucide-react";
import { IoCheckmark, IoAttachOutline, IoSend } from "react-icons/io5";
import { TbLocationFilled } from "react-icons/tb";
import { FaChevronUp } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import { BsChevronUp } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import DefaultAvatar from "../../assets/images/default_avatar.png";

const initialMessages = [
  {
    id: "1",
    text: "Lorem ipsum",
    time: "13:30",
    isAdmin: false,
    userName: "Liam Jackson",
  },
  {
    id: "2",
    text: "Lorem ipsum",
    time: "13:30",
    isAdmin: true,
    userName: "Admin",
  },
  {
    id: "3",
    text: "Lorem ipsum",
    time: "13:30",
    isAdmin: false,
    userName: "Liam Jackson",
  },
  {
    id: "4",
    text: "Lorem ipsum",
    time: "13:30",
    isAdmin: true,
    userName: "Admin",
  },
  {
    id: "5",
    text: "Lorem ipsum",
    time: "13:30",
    isAdmin: false,
    userName: "Liam Jackson",
  },
  {
    id: "6",
    text: (
      <>
        We need following documents
        <br />
        <ol>
          <li>Document</li>
          <li>Document</li>
          <li>Document</li>
        </ol>
      </>
    ),
    time: "13:30",
    isAdmin: true,
    userName: "Admin",
  },
];

const Chat = ({ onClose, title = "Liam Jackson", avatar }) => {
  const { t, i18n } = useTranslation();
  const [messages, setMessages] = useState(initialMessages);
  const [newMessage, setNewMessage] = useState("");

  const avatarSrc = avatar || DefaultAvatar;
  const isRtl = (i18n.language || "").toLowerCase().startsWith("ar");

  const handleSendMessage = () => {
    if (newMessage.trim()) {
      const message = {
        id: Date.now().toString(),
        text: newMessage,
        time: "00:00",
        isAdmin: false,
      };
      setMessages([...messages, message]);
      setNewMessage("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSendMessage();
    }
  };

  return (
    <>
      <div
        className={`${styles.chatMain} ${isRtl ? styles.chatMainRtl : ""}`}
        dir={isRtl ? "rtl" : "ltr"}
      >
        <div className={styles.innerWrapper}>
          <div className={`${styles["settings-card"]}`}>
            <div className={styles.chatContainer}>
              {/* Chat Header */}
              <div className={styles.chatHeader}>
                <div className={styles.chatHeaderLeft}>
                  <img
                    src={avatarSrc}
                    alt={t("chat.userAvatarAlt")}
                    className={styles.userImg}
                    onError={(e) => {
                      e.currentTarget.src = DefaultAvatar;
                    }}
                  />
                  <h6 className={styles.chatTitle}>{title}</h6>
                </div>
                <button className={styles.iconButton} onClick={onClose}>
                  <FaXmark size={20} />
                </button>
              </div>

              {/* Messages */}
              <div className={styles.chatMessages}>
                {messages.map((message) => (
                  <div
                    key={message.id}
                    className={`${styles.messageWrapper} ${
                      message.isAdmin ? styles.adminTxt : styles.userTxt
                    }`}
                  >
                    {message.isAdmin && (
                      <div className={styles.userImgWrap}>
                        <img
                          src={avatarSrc}
                          alt={t("chat.userAvatarAlt")}
                          className={styles.userImg}
                          onError={(e) => {
                            e.currentTarget.src = DefaultAvatar;
                          }}
                        />
                      </div>
                    )}
                    <div className="">
                      <div className={styles.messageTime}>
                        {message.isAdmin && <>{title}&nbsp;|&nbsp;</>}
                        {message.time}{" "}
                      </div>
                      <div
                        className={`${styles.messageBubble} ${
                          message.isAdmin ? styles.admin : styles.user
                        }`}
                      >
                        <p className={styles.messageText}>{message.text} </p>
                        {/* <div className={styles.messageTimeSmall}>{message.time}</div> */}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Message Input */}
              <div className={styles.chatFooter}>
                {/* <button className={styles.iconButton}>
                  <Upload size={16} />
                  {t("chat.footer.upload")}
                </button> */}
                <div className={styles.inputWrapper}>
                  <input
                    type="text"
                    className={styles.inputField}
                    placeholder={t("chat.typeMessage")}
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                  <button>
                    <IoAttachOutline size={24} />
                  </button>
                  <button
                    className={styles.sendButton}
                    onClick={handleSendMessage}
                  >
                    <IoSend size={20} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Chat;
